import { cx } from '../../cx'
import styles from './SegmentedToggle.module.css'

export interface SegmentedOption {
  value: string
  label: string
  /** Dopisek mniejszą czcionką, np. „–20%" w cenniku (spec 07). */
  suffix?: string
}

export interface SegmentedToggleProps {
  label: string
  options: readonly SegmentedOption[]
  value: string
  onChange: (value: string) => void
  className?: string
}

export function SegmentedToggle({
  label,
  options,
  value,
  onChange,
  className,
}: SegmentedToggleProps) {
  return (
    <div className={cx(styles.root, className)} role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={cx(styles.option, option.value === value && styles.active)}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
          {option.suffix !== undefined ? (
            <span className={styles.suffix}>{option.suffix}</span>
          ) : null}
        </button>
      ))}
    </div>
  )
}
